import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import {NavItem} from '../../layouts/parametria-layout/nav.item';
import {Router} from "@angular/router";
import { MicrosoftAuthService } from '@pages/authentication/services/microsoft-auth.service';
@Component({
  selector: 'app-index',
  templateUrl: './index.component.html',
  styleUrls: ['./index.component.css']
})
export class IndexComponent implements OnInit {

  constructor(
    private router: Router,
    private microsoftAuthService: MicrosoftAuthService
  ) { }

  @ViewChild('sidenav') sidenav: MatSidenav;
  @ViewChild('modules') d1: ElementRef;
  isExpanded = true;
  showSubmenu: boolean = false;
  isShowing = false;
  showSubSubMenu: boolean = false;
  jsonModules: NavItem[];
  usser: any;

  ngOnInit(): void {
    
    this.jsonModules = JSON.parse(sessionStorage.getItem('Modules'));
    this.usser = JSON.parse(sessionStorage.getItem('Usser'));
  }
  logout(){
    const isMicrosoft = this.microsoftAuthService.logout();
    if (!isMicrosoft) {
      this.router.navigate(['sign-in']);
    }
  }
}
